import { Directive, inject } from '@angular/core';
import { BrokerService } from '@app/core/services/broker.service';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { map, switchMap } from 'rxjs';

@Directive({
  selector: '[appBrokerAutocomplete]',
  standalone: true
})
export class BrokerAutocompleteDirective {
  private _hostComponent = inject(AutoComplete);
  private _brokerService = inject(BrokerService);

  constructor() {
    this._hostComponent.completeMethod
      .asObservable()
      .pipe(switchMap((x) => this.searchBrokers(x)))
      .subscribe((brokers) => (this._hostComponent.suggestions = brokers));
  }

  searchBrokers(event: AutoCompleteCompleteEvent) {
    return this._brokerService.getAllBrokers().pipe(
      map((x) =>
        x
          .filter(
            (v) =>
              v.code.toString().startsWith(event.query) || v.name.toLowerCase().indexOf(event.query.toLowerCase()) > -1
          )
          .slice(0, 10)
          .map((x) => {
            const label = `${x.code} - ${x.name}`;
            return {
              selectedLabel: label,
              optionLabel: label.replace(new RegExp(event.query, 'gi'), (match) => `<strong>${match}</strong>`),
              code: x.code
            };
          })
      )
    );
  }
}
